import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dashboard from "../Pages/DashBoard/Dashboard";
import { MOBILE_HOME_MAX_WIDTH } from "../Utils/defaultHomePath";
import useAuthStore from "../Zustand/Store/useAuthStore";
import { getStudentHomePath } from "../Utils/isStudentUser";
import { resolveActiveWorkspace, WORKSPACES } from "../Utils/workspaces";

/**
 * App home ("/"): student portal, Organizations (cards) on mobile, Dashboard on desktop.
 */
export default function HomeEntry() {
  const navigate = useNavigate();
  const { userData } = useAuthStore();
  const isMobile = useMediaQuery(`(max-width:${MOBILE_HOME_MAX_WIDTH}px)`, {
    noSsr: true,
  });

  const isStudentWorkspace =
    resolveActiveWorkspace(userData) === WORKSPACES.STUDENT;

  useEffect(() => {
    if (isStudentWorkspace) {
      navigate(getStudentHomePath(), { replace: true });
      return;
    }
    if (isMobile) {
      navigate("/organization/details", { replace: true });
    }
  }, [isMobile, isStudentWorkspace, navigate, userData]);

  if (isStudentWorkspace) {
    return <Navigate to={getStudentHomePath()} replace />;
  }

  if (isMobile) {
    return <Navigate to="/organization/details" replace />;
  }

  return <Dashboard />;
}
